import { Inline } from '../../../../design-system/inline/inline';
import { AccountView } from '../../../../types/entity-types';
import { getAccountDisplayName } from '../../../../utils/accounts/get-account-display-name';

type AccountSelectedItemProps = {
  account: AccountView;
};

export const AccountSelectedItem = ({ account }: AccountSelectedItemProps) => {
  const accountName = getAccountDisplayName(account);

  return (
    <Inline space={2} wrap="nowrap" align="center">
      {account.institution?.logo && (
        <div className="size-6 shrink-0 overflow-hidden rounded-full">
          <img src={account.institution.logo} alt="" className="h-full w-full object-cover" />
        </div>
      )}

      <span className="text-base font-medium text-foreground">{accountName}</span>
    </Inline>
  );
};
